import classNames from "classnames/bind";
import { RhLink } from "@components";
import { getLinkData } from "@/core/utils";
import { TopLevelNavigation } from "@header";
import ArrowTailRight from "@/assets/svg/arrow-tail-right-no-padding.svg";
import ExternalArrow from "@/assets/svg/external-arrow.svg";

import styles from './SecondaryLink.module.scss';
const cx = classNames.bind(styles);

type SecondaryLinkProps = Omit<TopLevelNavigation[number]["linkGroups"][number]['links'][number], '__typename'> & {
  className?: string;
};

export default function SecondaryLink(props: SecondaryLinkProps) {
  const linkData = getLinkData(props);
  const { className } = props;
  if (!linkData) return null;
  const Icon = props?.linkType?.[0] === 'external' ? ExternalArrow : ArrowTailRight;
  return (
    <RhLink href={linkData.url} target={linkData.target} className={cx(["secondary-link", className])} data-gtm-section="nav">
      <span className={cx(["label", "title-lc-xs"])}>{linkData.label}</span>
      <Icon className={cx("icon")} />
    </RhLink>
  );
}